import styled from 'styled-components'

export const SearchAutocompleteLoadingWrapperUi = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 20px;
`
